import { render, staticRenderFns } from "./OtherDimensionView.vue?vue&type=template&id=2d0361e2&scoped=true&"
import script from "./OtherDimensionView.vue?vue&type=script&lang=ts&"
export * from "./OtherDimensionView.vue?vue&type=script&lang=ts&"
import style0 from "./OtherDimensionView.vue?vue&type=style&index=0&id=2d0361e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0361e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAutocomplete,VBtn,VCol,VIcon,VRow,VSimpleTable,VTooltip})
